/*
 * PanamaJack — Seguno Back-in-Stock: muestra el widget de aviso de reposición solo
 * cuando la talla/variante seleccionada NO tiene stock; lo oculta en cualquier otro caso.
 * Extraído de theme.js durante el rebase a Showcase 10.2.0 (iso-funcional).
 * Requiere jQuery (theme.jQuery con fallback a jQuery global).
 *
 * 10.2.0: escucha el evento nativo 'on:variant:change' del <variant-picker> (bubbles a document)
 * y usa e.detail.variant.available. (Antes 6.0.0: 'cc-variant-updated' + selector .clickyboxes.)
 */
(function () {
  var $ = (window.theme && window.theme.jQuery) || window.jQuery;
  if (!$) return;

  $(function () {
    function toggleSegunoBackInStock(show) {
      if (show) {
        $('[id*="seguno_email_back_in_stock"]').show();
        $("seguno-back-in-stock").each(function () {
          var shadowRoot = this.shadowRoot;
          if (shadowRoot) {
            var wrapper = shadowRoot.querySelector("#wrapper");
            if (wrapper) wrapper.style.display = "block";
          }
        });
      } else {
        $('[id*="seguno_email_back_in_stock"]').hide();
        $("seguno-back-in-stock").each(function () {
          var shadowRoot = this.shadowRoot;
          if (shadowRoot) {
            var wrapper = shadowRoot.querySelector("#wrapper");
            if (wrapper) wrapper.style.display = "none";
          }
        });
      }
    }

    toggleSegunoBackInStock(false);

    // 10.2.0: el <variant-picker> nativo dispara on:variant:change (bubbles a document) al
    // seleccionar variante. Mostramos el widget Seguno solo si la variante elegida no tiene stock.
    document.addEventListener("on:variant:change", function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) {
        toggleSegunoBackInStock(false);
        return;
      }
      toggleSegunoBackInStock(!variant.available);
    });
  });
})();
